<template>
  <div class="image-search">
    <div class="field">
      <div class="control">
        <span v-if="!searching" @click="search" class="search icon is-small is-right"><i class="fal fa-search" qa="img-search-button"></i></span>
        <span v-if="searching" class="search icon is-small is-right"><span class="loader"></span></span>
        <input type="text" class="input" v-model.trim="query" @keyup.enter="search" v-bind:placeholder="placeholder" maxlength="50" :disabled="searching" qa="pexel-img-input"/>
      </div>
      <div v-if="error" class="help has-text-danger">{{error}}</div>
      <div v-if="noResults && query === lastQuery" class="has-text-grey">{{ $t('projectPage.noImages') }} <i>{{query}}</i> {{ $t('projectPage.wereFound') }}</div>
    </div>
    <div v-if="images.length > 0" class="columns is-multiline is-mobile">
      <div class="column is-one-quarter" v-for="image in images" :key="image.id" @click="select(image.src.large)">
        <img :src="image.src.smallSquare" />
      </div>
    </div>
    <div v-if="images.length > 0 && hasMore" class="load-more">
      <a @click="search">{{ $t('loadMore') }}</a>
    </div>
  </div>
</template>

<script>
import posts from '@/api/posts'
import breakpoints from '@/libs/breakpoints'
import i18n from '@/i18n'

export default {
  data: function () {
    return {
      query: '',
      lastQuery: '',
      page: 1,
      limit: 8,
      images: [],
      hasMore: true,
      error: '',
      searching: false,
      noResults: false
    }
  },
  computed: {
    placeholder: function () {
      return breakpoints.isMobile() ? i18n.t('searchPexelMobile') : i18n.t('searchPexel')
    }
  },
  methods: {
    search: function () {
      if (!this.query) {
        return
      }

      this.error = ''

      if (this.query !== this.lastQuery) {
        this.page = 1
        this.hasMore = true
        this.images = []
        this.searching = true
        this.noResults = false
      } else {
        if (!this.hasMore) {
          return
        }
        this.page++
      }

      posts.searchImages(this.query, this.limit, this.page).then((response) => {
        this.searching = false
        const result = response.data.result.images
        this.hasMore = result.hasMore
        this.images.push.apply(this.images, result.photos)
        this.lastQuery = this.query
        this.noResults = this.page === 1 && this.images.length === 0
      }, (error) => {
        this.error = error.message
      })
    },

    select: function (url) {
      this.$emit('selected', url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .search {
    position: absolute;
    z-index: 2;
    cursor: pointer;
    right: 1rem;
    top: 0.5rem;
  }
  .image-search {
    margin-top: 1rem;
  }

  img {
    cursor: pointer;
  }

  .credit {
    font-size: 0.75rem;
    position: absolute;
    top: 0;
    right: 0.5rem;
    line-height: 2.3rem
  }

  .load-more {
    text-align: center;
  }
</style>
